function $bc0107442a6480ae$export$2e2bcd8739ae039() {
    if (window.Splide && document.querySelector(".splide")) new window.Splide(".splide").mount();
}


const $ad8909e46d93e4f9$var$hamburger = document.getElementById("hamburger");
const $ad8909e46d93e4f9$var$navRightSide = document.getElementById("nav-right-side");
const $ad8909e46d93e4f9$var$mobileNav = document.getElementById("mobile-nav");
let $ad8909e46d93e4f9$var$mobileListItems = document.querySelectorAll(".nav__list--mobile .nav__list--item");
let $ad8909e46d93e4f9$var$bookButtons = document.querySelectorAll(".book-button");
let $ad8909e46d93e4f9$var$closeButton = document.querySelector(".modal__close");
let $ad8909e46d93e4f9$var$overlay = document.getElementById("overlay");
let $ad8909e46d93e4f9$var$modal = document.getElementById("modal");
let $ad8909e46d93e4f9$var$serviceButtons = document.getElementsByClassName("services-card__image-container");
let $ad8909e46d93e4f9$var$secondaryButtons = document.querySelectorAll(".secondary-button");
let $ad8909e46d93e4f9$var$serviceButtonArray = Array.from($ad8909e46d93e4f9$var$serviceButtons);
var $ad8909e46d93e4f9$export$2e2bcd8739ae039 = {
    hamburger: $ad8909e46d93e4f9$var$hamburger,
    navRightSide: $ad8909e46d93e4f9$var$navRightSide,
    mobileNav: $ad8909e46d93e4f9$var$mobileNav,
    mobileListItems: $ad8909e46d93e4f9$var$mobileListItems,
    bookButtons: $ad8909e46d93e4f9$var$bookButtons,
    closeButton: $ad8909e46d93e4f9$var$closeButton,
    overlay: $ad8909e46d93e4f9$var$overlay,
    modal: $ad8909e46d93e4f9$var$modal,
    serviceButtons: $ad8909e46d93e4f9$var$serviceButtons,
    secondaryButtons: $ad8909e46d93e4f9$var$secondaryButtons,
    serviceButtonArray: $ad8909e46d93e4f9$var$serviceButtonArray
};



const { hamburger: $ddf780f19af80d13$var$hamburger, navRightSide: $ddf780f19af80d13$var$navRightSide, mobileListItems: $ddf780f19af80d13$var$mobileListItems } = (0, $ad8909e46d93e4f9$export$2e2bcd8739ae039);
function $ddf780f19af80d13$export$5f78d73373efa618() {
    $ddf780f19af80d13$var$hamburger.classList.remove("is-active");
    $ddf780f19af80d13$var$navRightSide.classList.remove("nav-active");
    $ddf780f19af80d13$var$hamburger.setAttribute("aria-expanded", "false");
    $ddf780f19af80d13$var$hamburger.setAttribute("aria-label", "Open menu");
}
function $ddf780f19af80d13$export$5681aab4e1d4cd7d() {
    $ddf780f19af80d13$var$hamburger.addEventListener("click", ()=>{
        const open = $ddf780f19af80d13$var$hamburger.getAttribute("aria-expanded") !== "true";
        $ddf780f19af80d13$var$hamburger.classList.toggle("is-active", open);
        $ddf780f19af80d13$var$navRightSide.classList.toggle("nav-active", open);
        $ddf780f19af80d13$var$hamburger.setAttribute("aria-expanded", String(open));
        $ddf780f19af80d13$var$hamburger.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && $ddf780f19af80d13$var$hamburger.getAttribute("aria-expanded") === "true") {
            $ddf780f19af80d13$export$5f78d73373efa618();
            $ddf780f19af80d13$var$hamburger.focus();
        }
    });
}
function $ddf780f19af80d13$export$fd8badd0bc576b9e() {
    $ddf780f19af80d13$var$mobileListItems.forEach((item)=>item.addEventListener("click", $ddf780f19af80d13$export$5f78d73373efa618));
}


const { hamburger: $e9c923d409728e81$var$hamburger, bookButtons: $e9c923d409728e81$var$bookButtons, closeButton: $e9c923d409728e81$var$closeButton, overlay: $e9c923d409728e81$var$overlay, modal: $e9c923d409728e81$var$modal, secondaryButtons: $e9c923d409728e81$var$secondaryButtons, serviceButtonArray: $e9c923d409728e81$var$serviceButtonArray } = (0, $ad8909e46d93e4f9$export$2e2bcd8739ae039);
function $e9c923d409728e81$export$2e2bcd8739ae039() {
    let returnFocus;
    let previousOverflow;
    let background = [];
    const focusable = ()=>Array.from($e9c923d409728e81$var$modal.querySelectorAll("a[href], button, [tabindex='0']"));
    function openModal(event) {
        event.preventDefault();
        if ($e9c923d409728e81$var$modal.classList.contains("active")) return;
        returnFocus = event.currentTarget.closest(".nav__list--mobile") ? $e9c923d409728e81$var$hamburger : event.currentTarget;
        (0, $ddf780f19af80d13$export$5f78d73373efa618)();
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        background = Array.from(document.body.children).filter((element)=>element !== $e9c923d409728e81$var$modal && element !== $e9c923d409728e81$var$overlay && element.tagName !== "SCRIPT").map((element)=>({
                element: element,
                inert: element.inert
            }));
        background.forEach(({ element: element })=>{
            element.inert = true;
        });
        $e9c923d409728e81$var$overlay.classList.add("active");
        $e9c923d409728e81$var$modal.classList.add("active");
        $e9c923d409728e81$var$modal.setAttribute("aria-hidden", "false");
        $e9c923d409728e81$var$closeButton.focus();
    }
    function closeModal() {
        if (!$e9c923d409728e81$var$modal.classList.contains("active")) return;
        $e9c923d409728e81$var$overlay.classList.remove("active");
        $e9c923d409728e81$var$modal.classList.remove("active");
        $e9c923d409728e81$var$modal.setAttribute("aria-hidden", "true");
        document.body.style.overflow = previousOverflow;
        background.forEach(({ element: element, inert: inert })=>{
            element.inert = inert;
        });
        returnFocus?.focus();
    }
    [
        ...$e9c923d409728e81$var$bookButtons,
        ...$e9c923d409728e81$var$secondaryButtons,
        ...$e9c923d409728e81$var$serviceButtonArray
    ].forEach((button)=>{
        button.addEventListener("click", openModal);
    });
    $e9c923d409728e81$var$closeButton.addEventListener("click", closeModal);
    $e9c923d409728e81$var$overlay.addEventListener("click", closeModal);
    document.addEventListener("keydown", (event)=>{
        if (!$e9c923d409728e81$var$modal.classList.contains("active")) return;
        if (event.key === "Escape") {
            event.preventDefault();
            closeModal();
        } else if (event.key === "Tab") {
            const items = focusable();
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && (document.activeElement === first || document.activeElement === $e9c923d409728e81$var$modal)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === $e9c923d409728e81$var$modal)) {
                event.preventDefault();
                first.focus();
            }
        }
    });
}



function $51e4681dff505f85$export$2e2bcd8739ae039() {
    (0, $e9c923d409728e81$export$2e2bcd8739ae039)();
    (0, $ddf780f19af80d13$export$5681aab4e1d4cd7d)();
    (0, $ddf780f19af80d13$export$fd8badd0bc576b9e)();
}


(0, $51e4681dff505f85$export$2e2bcd8739ae039)();
(0, $bc0107442a6480ae$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.10ea6cc4.js.map
